import BaseListPresenter from "../../base/BaseListPresenter";
import { liveQueryUseCase } from "../../usecases/livequery";

class JobPortalListPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
    signOutUseCase
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      signOutUseCase
    );
    this.upsertUseCase = upsertUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.signOutUseCase = signOutUseCase;
  }

  componentDidMount() {
    this.init();
    this.subscribe();
    return this.getObjects();
  }
  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  subscribe() {
    const query = {
      collection: "job_posting",
      where: {},
    };

    const insertSubscription = liveQueryUseCase().execute(query, "afterInsert");
    insertSubscription.on("create", (newProduct) => {
      console.count("COUNT", newProduct);
      this.objects?.unshift(newProduct);
      this.view.setObjects(this.objects);
    });

    const updateSubscription = liveQueryUseCase().execute(query, "afterUpdate");
    updateSubscription.on("update", (updatedProduct) => {
      const index = this.objects?.findIndex(
        (obj) => obj.id === updatedProduct.id
      );
      if (index !== -1) {
        this.objects[index] = updatedProduct;
        this.view.setObjects(this.objects);
      }
    });

    const deleteSubscription = liveQueryUseCase().execute(query, "afterDelete");
    deleteSubscription.on("delete", (deletedProduct) => {
      this.objects = this.objects.filter((obj) => obj.id !== deletedProduct.id);
      this.view.setObjects(this.objects);
    });

    [insertSubscription, updateSubscription, deleteSubscription].forEach(
      (subscription) => {
        subscription.on("error", (error) => {
          console.error("Subscription error:", error);
        });
      }
    );
  }
  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const now = new Date();
    const utcMidnight = new Date(now.getTime() + 8 * 60 * 60 * 1000);
    utcMidnight.setUTCHours(0, 0, 0, 0);

    const todayISO = utcMidnight.toISOString();

    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, {
        where: { deadline: { $gte: todayISO } },
      });

      this.view.setState({ objects, filteredObjects: objects });
      // this.view.setState({ objects: objects });
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      this.init();
    }
  }

  reset() {
    if (this.view.state.objects.length === 0) {
      this.view.setState({ objects: [] });
    }
  }

  displayObjects(object) {
    this.view.setObjects(this.objects);

    this.view.navigateTo("/form/collection/" + object.id);

    this.view.setCount(this.objects.length);

    this.view.setState({
      schema: this.view.getSchemas(this.view.getCollectionName),
    });
  }

  onClickApplyNow() {
    const isWalkIn = this.view.isApplicantWalkIn();
    const user = this.view.getCurrentUser();
    const userInLocal = localStorage.getItem("user");

    const userCredentials = user ? user : userInLocal;
    const selected = this.view.getSelectedItems();
    if (isWalkIn) {
      localStorage.setItem("selectedJobs", JSON.stringify(selected));
      this.view.navigateTo(`/application-form/walkin_applicants`);
    } else {
      if (userCredentials) {
        localStorage.setItem("selectedJobs", JSON.stringify(selected));
        this.view.navigateTo(`/job-list/application-form/`);
      } else {
        localStorage.setItem("selectedJobs", JSON.stringify(selected));
        this.view.navigateTo(`/signin`);
      }
    }
  }

  onClickSignOut() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to sign out?",
      positiveButton: "SIGN OUT",
    };

    this.view
      .showDialog(options)
      .then(() => this.signOutUseCase.execute())
      .then(() => {
        localStorage.removeItem("selectedJobs");
        localStorage.removeItem("user");
        this.view.navigateTo("/signin");
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }
}

export default JobPortalListPagePresenter;
